import styled from "styled-components";
import { Colors } from "@smartsuite/types";

export const Wrapper = styled.div`
  display: flex;
  margin: 0px 30px 30px 30px;
  padding: 15px 25px;
  background: ${Colors.dwRed}80;
`;

export const IconWrapper = styled.div`
  display: flex;
  padding-right: 15px;
  padding-left: 5px;
  align-items: center;
  justify-content: center;
`;

export const Disclamer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Title = styled.div`
  font-weight: 500;
`;
export const Message = styled.div``;

export const Link = styled.span`
  .link {
    color: ${Colors.custom15};
    text-decoration: underline;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  gap: 10px;
  margin-left: 15px;
  align-self: center;

  .reached-limit-upgrade__button-contact {
    min-width: max-content;
    svg {
      height: 12px !important;
      width: 12px !important;
    }
  }

  .reached-limit-upgrade__button-usage {
    min-width: max-content;
    svg {
      height: 16px;
      width: 16px;
    }
  }

  .reached-limit-upgrade__button {
    min-width: max-content;
  }
`;

export const buttonStyles = {
  whiteSpace: "nowrap",
  marginLeft: "auto",
};
